import { takeLatest, put, call } from 'redux-saga/effects';
import { implementPromiseAction } from '@adobe/redux-saga-promise';
import _get from 'lodash/get';
import { getQueryParams } from '../../../../src/utils/utils';

import api from '../../../utils/apiConfig';
import UrlConfig from '../../../utils/urlHelper';
import { FETCH_VEHICLE_DATA, FETCH_WALLET_BALANCE } from './constants';
import { setVehicleData, setWalletBalance } from './actions';
import { setVehicleDetail } from '../../Fastag/Detail/actions';
import { rechargeFastag, setMinBalance, autoRecharge } from './promiseAction';

interface Url {
  fetchVehicleData: Function;
  fetchWalletBalance: Function;
  autoRechargeFasTag: Function;
  rechargeFastag: Function;
  setMinimumBalance: Function;
}

const urlHelper: Url = UrlConfig;

// worker Saga: will be fired on FETCH_VEHICLE_DATA actions
function* fetchVehicleData(action: any) {
  try {
    const params = getQueryParams();
    const response = yield api.get(urlHelper.fetchVehicleData(action.data.query), {
      headers: { locale: params.locale ? params.locale : 'en' },
    });
    const responseData = response.data;
    let data = _get(responseData, 'data', {});
    if (action.data.isDetail) {
      yield put(setVehicleDetail({ ...data, vNum: action.data.vNum }));
    } else {
      if (action.data.noReset) {
        data = { ...data, noReset: true };
      }
      yield put(setVehicleData(data));
    }
  } catch (e) {
    if (action.data.isDetail) {
      yield put(setVehicleDetail({}));
    } else {
      yield put(setVehicleData({}));
    }
  }
}

function* fetchWalletBalance() {
  try {
    const response = yield api.get(urlHelper.fetchWalletBalance());
    const responseData = response.data;
    if (responseData.success) {
      yield put(setWalletBalance(_get(responseData, 'data.walletBalance', '')));
    } else {
      yield put(setWalletBalance());
    }
  } catch (e) {
    yield put(setWalletBalance());
  }
}

function* handleRecharge(action: any) {
  try {
    yield call(implementPromiseAction, action, function* () {
      const { id, recharge, minBal } = action.payload;
      const params = {
        fastagId: id,
        minBalance: minBal,
        autoRechargeActivate: recharge,
      };
      return yield call(() => api.put(urlHelper.autoRechargeFasTag(), params));
    });
  } catch (err) {}
}

function* rechargeFastagWallet(action: any) {
  try {
    yield call(implementPromiseAction, action, function* () {
      const { tagId, amount } = action.payload;
      return yield call(() => api.post(urlHelper.rechargeFastag(), { tagId, amount }));
    });
  } catch (err) {}
}

function* setMinimumBalance(action: any) {
  try {
    yield call(implementPromiseAction, action, function* () {
      return yield call(() => api.put(urlHelper.setMinimumBalance(), action.payload));
    });
  } catch (err) {}
}

/*
  Does not allow concurrent fetches of user. If "FETCH_VEHICLE_DATA" gets
  dispatched while a fetch is already pending, that pending fetch is cancelled
  and only the latest one will be run.
*/
function* mySaga() {
  yield takeLatest(FETCH_VEHICLE_DATA, fetchVehicleData);
  yield takeLatest(FETCH_WALLET_BALANCE, fetchWalletBalance);
  yield takeLatest(autoRecharge, handleRecharge);
  yield takeLatest(rechargeFastag, rechargeFastagWallet);
  yield takeLatest(setMinBalance, setMinimumBalance);
}

export default mySaga;
